import { render, staticRenderFns } from "./win3.vue?vue&type=template&id=4f7a24ba&scoped=true"
import script from "./win3.vue?vue&type=script&lang=js"
export * from "./win3.vue?vue&type=script&lang=js"
import style0 from "./win3.vue?vue&type=style&index=0&id=4f7a24ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a24ba",
  null
  
)

export default component.exports